<!--cxone modal -->
<div *ngIf="isCXone">
    <div class="modal-body cxone-error-body">
        <div class="cxone-confirm-header">
            <svg class="icon-24 fill-warningYellow mr-2">
                <use href="../App_Themes/CXone/icons/modal-warning.svg#modal-warning"></use>
            </svg>
            <h4 class="modal-title cxone-confirm-title" id="modal-title">{{ title }}</h4>
            <button *ngIf="isCXone" id="confirm-dialog-close" type="button" class="icon-btn modal-close" aria-describedby="modal-title" (click)="modal.dismiss()">
                <svg class="icon-12 fill-iconDefault">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>
        <p class="cxone-confirm-text">{{ prompt }}</p>
    </div>
    <div class="modal-footer">
        <button id="confirm-dialog-cancel" type="button" class="btn btn-secondary modal-footer-btn" (click)="modal.dismiss()" ngbAutofocus>
            <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
        </button>
        <button id="confirm-dialog-ok" type="button" class="btn btn-primary cxone-btn modal-footer-btn" (click)="modal.close()">
            <span cvLocalizedText langSection="Common" langKey="OK">Ok</span>
        </button>
    </div>
</div>

<!-- normal modal -->
<div *ngIf="!isCXone">
    <div class="modal-header">
        <svg class="icon-24 fill-warningYellow mr-2">
            <use href="../App_Themes/CXone/icons/modal-warning.svg#modal-warning"></use>
        </svg>
        <h4 class="modal-title" [ngClass]="{ 'cxone-confirm-title': isCXone}" id="modal-title">{{ title }}</h4>
        <button *ngIf="isCXone" id="confirm-dialog-close" type="button" class="icon-btn modal-close" aria-describedby="modal-title" (click)="modal.dismiss()">
            <svg class="icon-12 fill-iconDefault">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </button>
        <button *ngIf="!isCXone" id="confirm-dialog-close" type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div [ngClass]="{'cxone-confirm-body': isCXone }" class="modal-body">
        <p>{{ prompt }}</p>
    </div>
    <div [ngClass]="{'cxone-confirm-footer': isCXone }" class="modal-footer">
        <button id="confirm-dialog-cancel" type="button" [ngClass]="{'cxone-btn, btn-secondary, modal-footer-btn': isCXone, 'btn-text': !isCXone}" class="btn" (click)="modal.dismiss()" ngbAutofocus>
            <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
        </button>
        <button id="confirm-dialog-ok" type="button" class="btn btn-primary" [ngClass]="{'cxone-btn, modal-footer-btn': isCXone}" (click)="modal.close()">
            <span cvLocalizedText langSection="Common" langKey="OK">Ok</span>
        </button>
    </div>
</div>
